export var VoiceApiStatus;
(function (VoiceApiStatus) {
    VoiceApiStatus["Success"] = "Success";
    VoiceApiStatus["Fail"] = "Fail";
})(VoiceApiStatus || (VoiceApiStatus = {}));
//# sourceMappingURL=voiceApiStatus.js.map